<template>
  <b-row
    v-if="showType == 'form-builder'"
    class="row-container"
    :class="selectedElementControlId == id ? 'row-container-selected' : ''"
    :style="properties.style"
    @click.stop.prevent="setSelected"
  >
    <slot></slot>
  </b-row>
  <b-row
    v-else-if="showType == 'form-submitter' || showType == 'e-form'"
    :style="
      superComputeFormSubmitterValue({
        elementId: this.id,
        property: 'style',
        value: properties.style,
        defaultValue: '',
        form: this.form
      })
    "
  >
    <slot></slot>
  </b-row>
  <b-row
    v-else-if="showType == 'form-viewer'"
    :style="
      superComputeFormSubmitterValue({
        elementId: this.id,
        property: 'style',
        value: properties.style,
        defaultValue: '',
        form: this.form
      })
    "
  >
    <slot></slot>
  </b-row>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "RowV1",
  props: ["properties", "showType", "id", "form", "formId"],
  methods: {
    deleteRow() {
      this.$emit("delete-row");
    },
    setSelected() {
      this.$emit("set-selected");
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm[this.id]
        ? this.computedPropertiesForm[this.id][property]
          ? this.computedPropertiesForm[this.id][property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      return `<div class="row" style="${this.getComponentComputedProperties(
        "style"
      )}"><slot></slot></div>`;
    }
  },
  computed: {
    ...mapGetters("formSubmitter", ["superComputeFormSubmitterValue"]),
    ...mapState("formBuilder", {
      forms: state => state.form
    }),
    ...mapState("formSubmitter", {
      computedPropertiesForm: state => {
        return state.form.computedProperties;
      }
    }),
    selectedElementControlId() {
      return this.forms[this.formId].selectedElementControlId;
    }
  }
};
</script>

<style>
.row-container {
  position: relative;
}

.row-container:hover .delete-row {
  display: block !important;
}
.delete-row {
  position: absolute;
  top: 0px;
  right: 0px;
}
</style>
